import React from "react";
import HeroImage from "../assets/heroImage.png";
// import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-scroll";
import { SparklesCore } from "./ui/sparkles";
import { InteractiveHoverButton } from "./ui/interactive-hover-button";
import { FlipWords } from "./ui/flip-words";

const Home = () => {
  const words = [
    "AI Native Developer",
    "Full Stack Developer",
    "RAG & LLM Engineer",
    "Software Engineer",
  ];

  return (
    <div
      name="home"
      className="min-h-screen w-full bg-gradient-to-b from-black via-black to-gray-800 relative overflow-hidden"
    >
      {/* Sparkles Background */}
      <div className="absolute inset-0 w-full h-full">
        <SparklesCore
          id="tsparticlesfullpage"
          background="transparent"
          minSize={0.6}
          maxSize={1.4}
          particleDensity={100}
          className="w-full h-full"
          particleColor="#FFFFFF"
        />
      </div>

      {/* Content */}
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center min-h-screen px-4 pt-28 pb-12 md:flex-row md:pt-20 md:pb-0 relative z-10">
        <div className="flex flex-col justify-center w-full md:w-auto">
          <p className="text-cyan-400 font-medium tracking-wide mb-2">
            Hi, I'm Fahim Al Rashid
          </p>
          <h2 className="text-4xl sm:text-6xl md:text-7xl font-bold text-white">
            <span className="block min-h-[2.5em] sm:min-h-[1.3em]">
              <FlipWords words={words} className="text-cyan-400 !px-0" />
            </span>
          </h2>
          <p className="text-gray-400 py-4 max-w-md">
            I build AI-native products — RAG pipelines, LLM chatbots, and
            AI-powered automations — on top of scalable web applications using
            React, Next.js, and FastAPI. B.Sc. in CSE, currently pursuing an
            M.Sc.
          </p>

          <div>
            <Link to="portfolio" smooth duration={500}>
              <InteractiveHoverButton
                text="Portfolio"
                className="w-40 text-base shadow-lg shadow-cyan-500/50"
              />
            </Link>
          </div>
        </div>

        <div className="mt-8 md:mt-0">
          <img
            src={HeroImage}
            alt="my profile"
            className="rounded-full mx-auto w-2/3 max-w-[300px] md:max-w-none md:w-96"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
